import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { Alert, AlertDescription, AlertTitle } from '../ui/alert';
import { CheckCircle2, AlertTriangle, XCircle } from 'lucide-react';

export function ImportResultStep({ importResult, onClose }) {
  if (!importResult) return null;

  const isSuccess = importResult.status === 'success';

  return (
    <div className="space-y-6">
      <div className="text-center">
        {isSuccess ? (
          <CheckCircle2 className="w-16 h-16 mx-auto text-emerald-500 mb-4" />
        ) : (
          <AlertTriangle className="w-16 h-16 mx-auto text-amber-500 mb-4" />
        )}
        <h3 className="text-lg font-semibold mb-2">
          {isSuccess ? 'Import Completato!' : 'Import completato con avvisi'}
        </h3>
      </div>

      <div className="grid grid-cols-3 gap-4">
        <Card className="bg-emerald-50 border-emerald-200">
          <CardContent className="pt-4 text-center">
            <div className="text-3xl font-bold text-emerald-700">{importResult.created}</div>
            <div className="text-sm text-emerald-600">Articoli creati</div>
          </CardContent>
        </Card>
        <Card className="bg-blue-50 border-blue-200">
          <CardContent className="pt-4 text-center">
            <div className="text-3xl font-bold text-blue-700">{importResult.updated}</div>
            <div className="text-sm text-blue-600">Articoli aggiornati</div>
          </CardContent>
        </Card>
        <Card className={`${importResult.errors?.length > 0 ? 'bg-red-50 border-red-200' : 'bg-gray-50'}`}>
          <CardContent className="pt-4 text-center">
            <div className={`text-3xl font-bold ${importResult.errors?.length > 0 ? 'text-red-700' : ''}`}>
              {importResult.errors?.length || 0}
            </div>
            <div className="text-sm text-muted-foreground">Errori</div>
          </CardContent>
        </Card>
      </div>

      {importResult.errors?.length > 0 && (
        <Alert variant="destructive">
          <XCircle className="h-4 w-4" />
          <AlertTitle>Errori durante l'import</AlertTitle>
          <AlertDescription>
            <ul className="text-sm mt-2 space-y-1">
              {importResult.errors.slice(0, 5).map((err, i) => (
                <li key={`err-${err.item_code || i}-${i}`}>
                  <strong>{err.item_code}</strong>: {err.error}
                </li>
              ))}
            </ul>
          </AlertDescription>
        </Alert>
      )}

      <div className="flex justify-center">
        <Button onClick={onClose} data-testid="close-import-btn">
          Chiudi
        </Button>
      </div>
    </div>
  );
}
